/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
    UserGroupToJSONTyped,
} from './UserGroup';

/**
 * 
 * @export
 * @interface CreateUserGroup201Response
 */
export interface CreateUserGroup201Response {
    /**
     * 
     */
    data?: UserGroup;
}

/**
 * Check if a given object implements the CreateUserGroup201Response interface.
 */
export function instanceOfCreateUserGroup201Response(value: object): value is CreateUserGroup201Response {
    return true;
}

export function CreateUserGroup201ResponseFromJSON(json: any): CreateUserGroup201Response {
    return CreateUserGroup201ResponseFromJSONTyped(json, false);
}

export function CreateUserGroup201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserGroup201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UserGroupFromJSON(json['data']),
    };
}

export function CreateUserGroup201ResponseToJSON(json: any): CreateUserGroup201Response {
    return CreateUserGroup201ResponseToJSONTyped(json, false);
}

export function CreateUserGroup201ResponseToJSONTyped(value?: CreateUserGroup201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserGroupToJSON(value['data']),
    };
}

